import { MaintenanceBundleType } from 'models/enums';

export const POST_INSPECTION_FLOW_STRINGS = {
  'placemat.title.no_steps_completed': `Hi there, {homeownerName}! I am excited to see we're making progress! I wanted to take a moment to introduce you to the rest of my team and next\u00a0steps.`,
  'placemat.title.no_steps_completed_move_out': `Hi there, {homeownerName}! We have an all-star team that is here to support you at any time. Let's\u00a0get\u00a0started!`,
  'placemat.title.at_least_one_step_completed': `Keep going, {homeownerName}! You're doing\u00a0great.`,
  'placemat.title.onl_improvement_steps_completed': `Alright, your home's going to look amazing! Now let's create a plan to get\u00a0it\u00a0loved.`,
  'placemat.improvements.title': 'Your home, up to Belong\u00a0Standards.',
  'placemat.pricing.title': 'Pricing. The key to lower\u00a0vacancy.',
  'placemat.team.title_multi_unit': 'Meet Your Team',
  'placemat.team.title': 'Meet Your Team For',

  // Bundle names
  [MaintenanceBundleType.CodeCompliance]: `Code {br}Compliance`,
  [MaintenanceBundleType.SafetyAndSecurity]: `Safety & {br}Security`,
  [MaintenanceBundleType.Habitability]: `Habitability {br}&\u00a0Comfort`,
  [MaintenanceBundleType.VacancyReduction]: `Vacancy {br}Reduction`,
  [MaintenanceBundleType.AppliancesAndEquipment]: `Appliances & {br}Equipment`,

  // Intro step
  'intro.title.onboarding': `Hi {homeownerName}! We got to see your lovely home during our inspection. Let's walk through our findings, starting with a short video on our\u00a0Standards.`,
  'intro.title.pre_move_out': `We’re looking forward to getting your home re-listed ASAP, {homeownerName}. To begin, let’s walk through the initial\u00a0findings.`,
  'intro.title.move_out': `With your Residents out, we came in to assess any damage your Residents are responsible for, as well as normal wear and tear that needs to be\u00a0addressed.`,
  // Intro — Readiness Walkthrough
  'intro.title.readiness_walkthrough': `Hi {homeownerName}! We've completed the Readiness Walkthrough of your home. Let's walk through what we found and why these final checks matter before your Residents move\u00a0in.`,
  'intro.address_suffix.readiness_walkthrough': `Readiness\u00a0Walkthrough\u00a0Plan`,
  'intro.next.readiness_walkthrough': `Review The Findings`,
  'intro.completed_on.readiness_walkthrough': `Readiness Walkthrough Completed On`,
  'intro.standards.title.readiness_walkthrough': `Belong's Open Standards define what move-in ready\u00a0means.`,
  'intro.standards.body.readiness_walkthrough': `A safe, comfortable home for your Residents from day\u00a0one.`,
  'intro.divider.readiness_walkthrough': [
    `Your home is safe and functional from day one.`,
    `Your Residents move in without surprises.`,
    `And they'll treat your home with love in return.`,
  ],
  'intro.explainer.title': `What is a Home Readiness Walkthrough?`,
  'intro.explainer.body': `Once the first round of improvements is complete, we perform another Walkthrough. This is an opportunity to inspect the work that has been done, catch issues that may have arisen since, and view the home through the eyes of the Residents who will be living there soon. Another pass allows us to prevent bad experiences once they move in, saving you money and headaches in the long\u00a0run.`,

  // Approval step
  'move_in_schedule.leased': `Your Residents move in {moveInOn}. Approving by {approveBy} ensures your Residents are able to move in on\u00a0time.`,

  // Intro step (Readiness Walkthrough)
  'move_in_on_track.title': `Let's keep your move-in on track.`,
  'move_in_on_track.body': `These findings are the last step before Residents move into your Home. With your approval, we'll clear any blockers and protect both your move-in date and your rental income.`,
  'move_in_on_track.blocks': [
    {
      key: 'resident-focused-review',
      title: `One Final Review`,
      body: `In this Walkthrough, we're checking to make sure your Home is ready to be lived in.`,
    },
    {
      key: 'nothing-slips-through',
      title: `Nothing slips through.`,
      body: `We'll catch issues that weren't visible at the first Walkthrough, or only appear once other work is done.`,
    },
    {
      key: 'protect-move-in-date',
      title: `Protect your move-in date.`,
      body: `We'll resolve these items quickly to keep your timeline intact and get your Residents in as planned.`,
    },
    {
      key: 'flexible-payment',
      title: `Flexible Payment Options`,
      body: `Financing may be available, and you have the option to pay once the approved work is complete as well.`,
    },
  ],
  'intro.next': `Let's get started!`,
  'intro.address_suffix': `Quality Plan`,
  'intro.completed_on': `Inspected On`,
  'intro.video.countdown': `You can start after watching video`,
  'intro.video.countdown_remaining': `({remainingTime})`,
  'intro.divider_section.title': `Belong's Rigorous Standards Of\u00a0Home\u00a0Excellence`,
  'intro.divider_section.whats_next': 'What’s Next',
  'intro.divider_section.body': `We're here to make sure your home is in tip-top shape, because homes treated with love have three key advantages that will save you money in the long\u00a0run.`,
  'intro.divider': [
    `Your home will rent faster, to\u00a0great\u00a0Residents.`,
    `These Residents will stay\u00a0longer.`,
    `And they'll treat your home with love in\u00a0return.`,
  ],
  'intro.checkmark_section.title': `To ensure your home was ready to go, we checked for the\u00a0following...`,
  'intro.inspected_by': `Inspected {inspectedOn}\u00a0By`,
  'intro.assessed_by': `Assessed {assessedOn}\u00a0By`,
  'intro.greenBox':
    'We need to move forward if this improvement report is not approved by {date}. This allows us to return the remaining resident’s security deposit in time. If we don’t, they are eligible to receive the full security\u00a0deposit.',

  'intro.next-steps.first.title': `Pre-Move-Out`,
  'intro.next-steps.second.title': `Post-Move-Out`,
  'intro.next-steps.common.title': `Standards Walkthrough & Quality\u00a0Improvements`,
  'intro.next-steps.first.content': `This includes items Residents are responsible for, and maintenance items that will increase your home’s appeal to potential Residents, making it quicker to get your home\u00a0loved.`,
  'intro.next-steps.second.content': `This includes items Residents are responsible for, and maintenance items that will increase your home’s appeal to potential Residents, making it quicker to get your home\u00a0loved.`,

  // Progress step (Readiness Walkthrough only)
  'progress.title': `To recap, here are the improvements we have completed in your Home so far. Check out the before and after\u00a0photos!`,
  'progress.section.title': `Walkthrough Improvements`,
  'progress.section.title.onboarding': `Onboarding Walkthrough\u00a0Improvements`,
  'progress.section.title.move_out': `Move-Out Walkthrough\u00a0Improvements`,
  'progress.section.body': `Belong has strict quality standards and requires photographic proof of all work completed in Belong\u00a0Homes.`,
  'progress.cta': `Looks good!`,
  'progress.item.completed': `Completed`,
  'progress.item.appointment': `Appointment`,
  'progress.media.previous': `Previous image`,
  'progress.media.next': `Next image`,
  'progress.stage.before': `Before`,
  'progress.stage.during': `During`,
  'progress.stage.after': `After`,
  'progress.status.completed': `Completed`,
  'progress.status.in_progress': `In Progress`,

  // Features step
  'features.title': `First, let’s verify the features we found in your home to ensure an accurate\u00a0listing.`,
  'features.divider.features_and_appliances': `Features & {br}Appliances`,
  'features.divider.unique_qualities': `Unique {br}Qualities`,
  'features.divider.unique_quirks': `Unique {br}Quirks`,
  'features.next': `Let’s proceed!`,
  'features.next_something_wrong': `Next`,
  'features.something_off': `Modify`,
  'features.tooltip.qualities': `Your home's qualitative selling points! You may not be able to see these in the photos, but you can feel them, and we'll make sure potential Residents know about them\u00a0too.`,
  'features.tooltip.quirks': `Every home has them. They take some getting used to, but our goal will be to find Residents that learn to love\u00a0them.`,

  'features.labeled_list.qualities.title': 'Unique Qualities',
  'features.labeled_list.qualities.label_text': 'Good',
  'features.labeled_list.quirks.title': 'Quirks',
  'features.labeled_list.quirks.label_text': 'Not Great',
  'features.form_section.title': 'Anything we missed or should modify?',
  'features.form_section.placeholder': 'Missing Features Or Corrections',

  // Turnovers Responsibility step
  'responsibility.title.pre_move_out': `At Belong, we believe in making sure your home is safe and secure and in condition to maximize your\u00a0earnings.`,
  'responsibility.title.move_out': `During our 200-point inspection, we found a few items to address. Don’t worry, we'll deduct anything residents are responsible for from the security\u00a0deposit.`,
  'responsibility.title.adopted_home': `During our 200-point inspection, we found a few items to address. Don’t worry, we'll deduct anything residents are responsible for from the security\u00a0deposit.`,
  'responsibility.title.move_out.deposit_free': `During our 200-point inspection, we found a few items to address. Don’t worry, we'll deduct anything residents are responsible for from the security\u00a0deposit.`,
  'responsibility.our_promise.title': `Our Promise To You`,
  'responsibility.next': 'Next',
  'responsibility.belong_standards.title': `Belong’s Standards`,
  'responsibility.wear_and_tear.title': 'Common Repairs In The Home',
  'responsibility.wear_and_tear_vs_resident_damage.title': `What is wear and tear vs. resident\u00a0damage?`,
  'responsibility.wear_and_tear_vs_resident_damage.resident.title':
    'Damage is always on\u00a0residents.',
  'responsibility.wear_and_tear_vs_resident_damage.resident.copy':
    'Resident’s are responsible for any damage beyond that caused by normal life in the\u00a0home.',
  'responsibility.wear_and_tear_vs_resident_damage.homeowner.title':
    'Homeowner Responsibilities',
  'responsibility.wear_and_tear_vs_resident_damage.homeowner.copy':
    'Homeowners are responsible for normal wear and tear and general maintenance of the\u00a0home. ',
  'responsibility.wear_and_tear.body': `We know it can be difficult to differentiate between “wear and tear” and excessive damages. To help, we’ve created side-by-side comparisons of the most common\u00a0repairs.`,
  'responsibility.deposit_deduction.title':
    'What are common security deposit deductions?',
  'responsibility.deposit_deduction.items': [
    'Improper Care Of Home',
    'Changing Batteries',
    'Improper Use Of Fixtures',
    'Pet Damage',
    'Painting Due To Damage',
    'Lost Keys',
    'Lost Remotes',
    'Lawn Care',
    'Light Bulbs',
    'Pool Care',
    'Changing Air Filters',
    'Toilet And Drain Clogs',
  ],

  // Improvements step (Review component)
  'improvements.title': `We then took {inspectorName}'s findings and broke them down into 5 categories. Here's how your\u00a0home\u00a0did.`,
  'improvements.title_no_improvements': `Let's not bury the lead. Your home is in great shape and ready to be loved. Kudos to you for keeping it\u00a0impeccable!`,
  'improvements.title_move_out': `Without further ado, here are some of the elements that will help get your home loved again as quickly as\u00a0possible.`,
  'improvements.title_no_improvements_move_out': `Let's not bury the lead. Your home is in great shape and ready to be loved. Kudos to {youAndResidents} for keeping it\u00a0impeccable!`,
  'improvements.flag.text': `Let's discuss!`,
  'improvements.by-you': 'Requested By You',
  'improvements.complimentary': 'Complimentary',
  'improvements.on-you': 'On You',
  'improvements.resident_responsibility': 'Resident Responsibility',
  'improvements.shared_responsibility': 'Shared Responsibility',
  'improvements.resident_responsibility.tooltip':
    'Due to excessive damages beyond normal wear and tear, your resident is fully responsible for the cost of this\u00a0repair.',
  'improvements.shared_responsibility.tooltip':
    "Based on our in-house expert's findings, your {party} is partially responsible for the cost of this\u00a0repair.",
  'improvements.required': `Belong requires any improvements needed to satisfy regulatory building codes. On top of this, we have developed a set of minimum standards designed to ensure Residents living in Belong homes feel cared for, so they in turn feel a sense of\u00a0responsibility.`,
  'improvements.recommended': `Belong recommends any improvements that make the home desirable to high-quality Residents and maximize the long-term value of the\u00a0home.`,
  'improvements.flagged': `Ok, I’ll reach out to discuss {thisOrThese} with you. In the meantime, feel free to move forward with the\u00a0rest.`,
  'improvements.optional': 'Optional',
  'improvements.TBD_reason.MultipleQuotesRequired': `In order to get you the best price possible, we'll want to seek multiple quotes for this\u00a0one.`,
  'improvements.TBD_reason.MultipleOptionsToDiscuss': `There are a few different paths we can take here. We'll go through all of this with you, and determine together the best path\u00a0forward.`,
  'improvements.TBD_reason.PendingFurtherInvestigation': `We weren't able to determine the issue onsite during the inspection. Looks like we'll need a specialist for this one to investigate further and determine the root\u00a0cause.`,

  // Quality step
  'quality.subtitle': 'We treat every home project as if it was our\u00a0own.',
  'quality.quality': 'Trusted Pros',
  'quality.qualityDescription':
    'We ensure top-notch improvements quality to maximize the long-term value of your\u00a0home.',
  'quality.penny': 'Not A Penny More',
  'quality.pennyDescription':
    'Never pay more than your approved limit. If our costs exceed your approval, we’ll cover the\u00a0difference.',
  'quality.guarantee': 'Guaranteed Time To List',
  'quality.guaranteeDescription':
    'When Belong handles all repairs, we list your home faster, and guarantee your professional listing\u00a0date.',
  'quality.liability': 'Liability Protection',
  'quality.liabilityDescription':
    'Unlicensed vendor accidents are costly. Belong’s licensed, bonded, insured vendors shield you from\u00a0risk.',
  'quality.title':
    'During the Walkthrough, we found a few items to take care of in accordance with the Belong\u00a0Standards.',
  'quality.title.noImprovements':
    'During our 200-point inspection, we found your home meets Belong\u00a0Standards! No repairs are needed before Residents move\u00a0in.',
  'quality.heading': `Backed By Belong's {br}Delightful\u00a0Guarantee`,
  'quality.headingTooltip': `We created the Belong Delightful Guarantee to ensure that every Belong Home is treated with the same level of care as each of our homes. If you aren’t satisfied with the work that was performed by one of Belong’s trusted Pros, we guarantee we will do the work again until the works is done\u00a0right.`,
  'quality.cta': `View Report`,
  'quality.cta.noImprovements': 'Done',
  'quality.secondary_cta': 'Learn More',
  'quality.pro_hero.pretitle': `That advantage starts with a simple\u00a0idea.`,
  'quality.pro_hero.title': `We treat your home as if it were our\u00a0own.`,
  'quality.checklist.title': `When we send Pros, they all meet 4 key\u00a0standards.`,
  'quality.maintenance_talent.title': `We ensure the best quality of work, all at market\u00a0rates.`,
  'quality.general_contractors.title': `Meet Milan, a member of our team of General\u00a0Contractors.`,
  'quality.general_contractors.subtitle': `He's obsessive about detail-oriented\u00a0craftsmanship. No\u00a0matter\u00a0how\u00a0big the\u00a0job\u00a0is.`,
  'quality.pro_hero2.title': `We'll nail it, whether your home has a leak, or needs a\u00a0new\u00a0bathroom.`,
  'quality.diy_section.title': `Why you can trust\u00a0Belong.`,
  'quality.diy_section.subtitle': `We require all work done on your home be performed by a trusted Pro for 3\u00a0reasons.`,
  'quality.data_speak': 'Let’s have the data speak for\u00a0itself.',
  'quality.horror_section.title': `Not convinced?`,
  'quality.horror_section.subtitle': `Check out some DIY gone\u00a0wrong.`,
  'quality.try_us.title': `Live in the area? Give\u00a0us\u00a0a\u00a0try!`,
  'quality.try_us.subtitle': `Something need fixing in your primary residence? We'd be happy to help with that too! Just let us know, and we'll send a Pro right\u00a0out.`,

  // Approval Step
  'approvals.title.readiness_walkthrough': `During the Readiness Walkthrough, we found a few more items to take care of before your Residents move in. Approve now to ensure your home is on track.`,
  'approvals.cta.readiness_walkthrough': `View Payment Options`,
  'approvals.section.required': `Required Before Move-In`,
  'approvals.section.recommended': `Recommended`,
  'approvals.title': `Let’s get your home ready, shall\u00a0we?`,
  'approvals.title.adpted_lease': `Let’s finalize these repairs to keep your home in top\u00a0condition.`,
  'approvals.title_with_gttl': `Approve these repairs, and we'll have your home professionally listed in {date} or\u00a0less.`,
  'approvals.title_with_gttlease': `Approve these repairs so we can list your home. From there, you’ll have a signed lease in an average of 21 days, and never more than {date}. Guaranteed, or the placement fee is on\u00a0us.`,
  'approvals.title_pre_move_out': `Check out what we found. We'll come back once your resident moves to finalize the list. You don’t owe anything at this\u00a0time.`,
  'approvals.title_move_out': `Let’s finalize these repairs to keep your home in top condition. We will deduct all repairs allowed by law from your Resident’s security\u00a0deposit.`,
  'approvals.title.ready_to_rent':
    "Belong offers multiple payment options for improvements, one of which is complimentary! After this, we'll list your home ASAP. From there, you'll have a signed lease in an average of 21 days, never more than 60. Guaranteed, or the placement fee is on\u00a0us.",
  'approvals.cta': `Sounds Good!`,
  'approvals.cta.onboarding': `View Payment Options`,
  'approvals.cta_no_approval': `Done`,
  'approvals.resident_responsibility.title': `Resident Responsibility`,
  'approvals.resident_responsibility.subtext': [
    `Below are the repair costs that your previous residents are responsible for. These charges will be deducted from their security\u00a0deposit.`,
  ],
  'approvals.inspirational.title': `Level Up Your Home (Optional) `,
  'approvals.inspirational.title_move_out': `Make Your Home Shine `,
  'approvals.inspirational.subtext': [
    `Depending on your budget, you may want to make your home even more desirable. It’s\u00a0up\u00a0to\u00a0you!`,
  ],
  'approvals.inspirational.subtext_move_out': [
    `Here are a few items that add value to your home and increase the likelihood of future residents living in your home long\u00a0term.`,
  ],
  'approvals.question.placeholder': `Other Improvements (OPTIONAL)`,
  'approvals.rewards.unlock.cost': `Add {cost} more to unlock.`,
  'approvals.rewards.unlock.all': `Add all packages to unlock.`,
  'approvals.rewards.unlock.amount': 'Save 10% when you invest {amounth}.',
  'approvals.paymentplan.title': `Ready to get your\u00a0home\u00a0loved?`,
  'approvals.paymentplan.flag.subtext': `We'll reach out to discuss any items you flagged. Your plan can still be modified after approving\u00a0here.`,
  'approvals.paymentplan.noflag.subtext': `Your plan can still be modified after\u00a0approving\u00a0here.`,
  'approvals.paymentplan.ach.subtext': `We'll use this account to pay you rent as\u00a0well.`,
  'approvals.importance.bundle.title.matter': 'Why {pronoun} {subject} {verb}',
  'approvals.importance.bundle.title.required':
    'Why {pronoun} {subject} {verb}\u00a0Required',
  'approvals.importance.modal': 'Why improve My Home\u00a0Now',
  'approvals.importance.title': 'Don’t fall into the “as\u00a0is”\u00a0trap!',
  'approvals.importance.subtitle':
    'Listing your home "as is" may seem like a good idea to save time. Some garden-variety property managers even encourage it. But brushing repairs under the rug causes major problems down\u00a0the\u00a0road.',
  'approvals.importance.vacancy.title': 'Lower Vacancy Upfront',
  'approvals.importance.vacancy.detail':
    'Without cosmetic issues, photos will stand out online, attracting more people to tour. Once onsite, people will jump to apply when they see the high standard of\u00a0care.',
  'approvals.importance.headaches.title': 'Save Yourself Headaches',
  'approvals.importance.headaches.detail':
    'When residents find things broken on move-in day, it’s a poor experience for them and a headache for you. You may even lose them if things go\u00a0unfixed.',
  'approvals.importance.cta': 'Sounds Good',
  'approvals.preventative.tooltip.title': 'Estimated Costs Prevented',
  'approvals.preventative.tooltip.detail':
    'Based on your selection of preventative work, this is an estimate of how much you will save in the long\u00a0run.',
  'approvals.vacancyReduction.tooltip.title':
    'Percent Reduction In Time to Love',
  'approvals.vacancyReduction.tooltip.detail':
    'Historically, homeowners who accepted these improvements got their home loved 21%\u00a0faster.',
  'approvals.summary.modal.title': 'Price Details',
  'approvals.summary.modal.plan': 'With {months}-Month Payment Plan',
  'approvals.summary.unlocked.discount': 'You’ve unlocked it!',
  'approvals.summary.remaining.balance': 'You are {balance} away!',
  'approvals.optional': 'Optional',
  'approvals.summary.cost': 'PRICING DETAILS',
  'approvals.payment.plan': 'Up To 12-Month Financing Available',
  'approvals.est': 'Est.',
  'approvals.est.total': 'Your Estimated Total',
  'approvals.total': 'Your Total',
  'approvals.payment.upon.completion': 'Upon Completion',
  'approvals.payment.from.rent': 'From Rent',
  'approvals.projectManagementFee.title': `What's Included`,
  'approvals.projectManagementFee.benefits.title': `Benefits`,

  //Homeowner Fixes
  'homeowner-fixes.title': `We can't wait to get your home listed, {firstName}! May we ask when the work you are tackling will be done, so we can get\u00a0started?`,
  'homeowner-fixes.date-placeholder': `Completion Date (MM/DD/YYYY)`,

  // Pricing - Get Started
  'pricing.getStarted.title': `Hi, {firstName}! We’re here to get your home loved as soon as possible. To start, let’s watch a short video on our strategy to do\u00a0so.`,
  'pricing.getStarted.title_second': `Hi, {firstName}! We’re here to get your home loved as soon as possible. To start, let’s watch a short video on our strategy to do\u00a0so.`,
  'pricing.tip.title': 'We’re 100% aligned with maximizing your\u00a0earnings!',
  'pricing.tip.content':
    'Since we only get paid once your home is loved, we are aligned in minimizing vacancy and maximizing your annual\u00a0income.',
  'pricing.getStarted.videoHint':
    'You can start after watching video ({remainingTime})',
  'pricing.getStarted.cta': `Let's get started!`,
  'pricing.getStarted.pricedOn': `Priced {month} {day} By`,

  // Pricing - Seasonality
  'pricing.seasonality.title': `It is important to understand how seasonality specifically impacts your home’s\u00a0earnings.`,
  'pricing.seasonality.listing_title': `Listing your home at market rate prevents extended\u00a0vacancy.`,
  'pricing.seasonality.listing_subtitle': `We receive 3x more resident leads per home between June and August. We automatically factor this seasonality into the pricing\u00a0strategy.`,
  'pricing.seasonality.impact_title': `Why does this happen?`,
  'pricing.seasonality.impact_content': `For starters, most residents are looking to move before labor day, making spring and summer the high demand\u00a0season.`,
  'pricing.seasonality.cta': `Next`,

  // Pricing - Marketing
  'pricing.marketing.title': `We create the absolute most beautiful listing for your home, and price to ensure as many eyes see it as\u00a0possible.`,
  'pricing.marketing.tabs.highResPhotos': `High-Res Photos`,
  'pricing.marketing.tab-text.highResPhotos': `They say a picture is worth a thousand words. We take high-resolution professional photos that properly show off what is unique about your\u00a0home.`,
  'pricing.marketing.tabs.threeDTours': `3D Tour`,
  'pricing.marketing.tab-text.threeDTours': `With 3D tours, potential residents spend a longer time looking at your listing and getting excited about the space. This increases the chance they take the next step to tour or\u00a0apply. `,
  'pricing.marketing.tabs.virtualTours': `Virtual Tours`,
  'pricing.marketing.tab-text.virtualTours': `Our virtual guided tour brings your home to life and may have you fall in love with your home all over\u00a0again.`,
  'pricing.marketing.tabs.allMajorListings': `All Major Listing Sites`,
  'pricing.marketing.tab-text.allMajorListings': `We have direct integrations with Zillow, Trulia, Zumper and Hotpads that generate 30% - 50% more views on your home on those\u00a0websites.`,
  'pricing.marketing.tabs.weeklyAndSelfTours': `Weekly Tours`,
  'pricing.marketing.tab-text.weeklyAndSelfTours': `We host 2+ group tours and many private tours every week. We’re also one of the only companies with identity verified self tours. Homes with self tours get more demand because potential residents can tour when it’s convenient for\u00a0them.`,
  'pricing.marketing.tip.title': 'Pro Tip',
  'pricing.marketing.tip.content-paragraph1':
    'Homes listed for 20+ days are most likely overpriced. Additionally, because many residents negotiate their rental price, the actual lease contract price is usually 10% less than the last published\u00a0price.',
  'pricing.marketing.cta': 'Next',
  'pricing.marketing.highRes':
    'They say a picture is worth a thousand words. We say a photo gallery is not worthy without drone photos and high resolution photos that properly show off what is unique about your\u00a0home.',
  'pricing.marketing.3dTour':
    'With 3D tours, potential residents spend a longer time looking at your listing and getting excited about the space. This increases the chance they take the next step to tour or\u00a0apply.',
  'pricing.marketing.allListings':
    'We have direct integrations with Zillow, Trulia, Zumper and Hotpads that generate 30%\u00a0- 50% more views on your home on those\u00a0websites.',

  // Pricing - maps
  'map.title': `Supply and demand dictates the price of your home, so let's check out the competition in your\u00a0neighborhood.`,
  'map.not_listed_1': `We can’t wait to get`,
  'map.not_listed_2': 'your home listed and loved\u00a0{heart}',

  'map.card.last_published': 'Last Published Listing\u00a0Price',
  'map.card.tooltip_title_1': 'Last Published Listing Price',
  'map.card.tooltip_subtitle_1': 'Helpful, but often inflated.',
  'map.card.tooltip_body_rental_1':
    'Keep in mind that rent is often negotiated down from the listing price, and the actual price is not\u00a0published.',
  'map.card.tooltip_body_rental_2':
    'Keep in mind Recently Rented Homes are negotiated down and final rental price is not published inflating this\u00a0number.',

  'map.card.days_listed': 'Days Listed',
  'map.card.tooltip_title_2': 'Days Listed',
  'map.card.tooltip_subtitle_2': 'A great indicator of the\u00a0market.',
  'map.card.tooltip_body_2':
    'The longer a home is listed, the more likely it is that that home is\u00a0mispriced.',

  'map.button': 'Next',

  // pricing - checkin
  'initial_listing.price_range_title':
    'Our data suggests that by listing in this range, as close to market rate as possible, you will maximize your earnings.',
  'initial_listing.requested_price_title':
    'Let’s start collecting marketing feedback by listing at the price you wanted, and go from\u00a0there.',
  'initial_listing.title':
    'Our goal is to list as closely to the market rate and adjust as quickly as possible. Our data suggests you will maximize your earnings by starting\u00a0here.',
  'initial_listing.price_range_banner.tag': 'Initial Listing Price\u00a0Range',
  'initial_listing.price_range_banner.benefit':
    'At time of listing, our pricing algorithm will choose a price in this range based on market indicators, with the goal of both reducing vacancy and maximizing price.',
  'initial_listing.requested_price_banner.tag': 'Your Requested Price',
  'initial_listing.requested_price_banner.auto_adjustments':
    'AUTOMATIC PRICE ADJUSTMENTS',
  'initial_listing.requested_price_banner.benefit':
    "Based on your feedback, we'll start listing at this price. From there, our algorithm will adjust the price periodically based on market feedback, with the goal of both reducing vacancy and maximizing cash flow.",
  'initial_listing.requested_price_cta.disclaimer':
    'To proceed with this amended pricing strategy, an upfront placement fee is required. Additionally, we are unable to guarantee the time to rent at\u00a0this\u00a0time.',
  'initial_listing.requested_price_cta.button': 'I Agree',
  'initial_listing.placement_fee_modal.title':
    'How would you like to pay the {amount} placement fee?',
  'initial_listing.placement_fee_modal.subtitle':
    'Choose the way you would like to pay for your placement fee.',
  'initial_listing.placement_fee_modal.pay_now': 'Pay Now',
  'initial_listing.placement_fee_modal.error':
    'Something went wrong processing your payment. Please try again.',
  'initial_listing.gttl_banner.tag':
    'Qualified For 60 Day\n Guaranteed Time To\u00a0Rent ',
  'initial_listing.gttl_banner.benefits': [
    'Rented In 21 Days On Average, Never\u00a0Exceeding\u00a060',
    'Maximum Rental Income',
    'Guaranteed Rent Payments',
    'Highest Quality Residents',
  ],
  'initial_listing.initial_listing_price': 'Initial Listing Price',
  'initial_listing.gttl_title': '60-Day Time To Rent\u00a0Guaranteed',
  'initial_listing.gttl_description':
    'By listing within this range, Belong Homes rent in 21 days on average. We guarantee you home will be loved by the 60th day, or the placement is\u00a0on\u00a0us.',
  'initial_listing.relationship':
    'How do you feel about your initial listing\u00a0price?',
  'initial_listing.estimated_rental_price': 'Estimated Rental Price',
  'initial_listing.estimated_rental_price_subtitle':
    'We think your home will end up renting\u00a0here',
  'initial_listing.initial_listing_price_sub':
    'We think your home will rent at this\u00a0price.',
  'initial_listing.modal.title': 'Thank you for sharing your\u00a0thoughts!',
  'initial_listing.modal.subtitle':
    'We will review and discuss with you before listing your\u00a0home.',
  'initial_listing.modal.button': 'Next',

  'initial_listing.tell-us-how-you-feel': `What's on your\u00a0mind?`,
  'initial_listing.initial_listing_price_subtitle':
    "Let's start ~{percentageAbove}% higher to\u00a0test\u00a0the\u00a0market",
  'initial_listing.initial_listing_price_subtitle.no_percentage':
    "Let's start the listing at this\u00a0price.",
  'initial_listing.approve': 'Approve',
  'initial_listing.next': 'Next',
  'initial_listing.discuss': 'Let’s Discuss',
  'initial_listing.employee_reminder': `We hear you. Keep in mind, once we list, we can always adjust price up if interest is\u00a0strong.`,
  'initial_listing.price_range_employee_reminder':
    'We hear you. Keep in mind, once we list, we can always adjust price up if interest is\u00a0strong.',
  'initial_listing.alt_tag': 'Home Image',

  // pricing - the market
  'the_market.title':
    'To maximize your annual earnings, we must balance rent price and\u00a0vacancy.',
  'the_market.grap.title':
    'A higher listing price doesn’t always generate more\u00a0earnings.',
  'the_market.grap.subtitle':
    'Overpricing creates long periods of vacancy. And every day without rent collection adds up to an overall loss in annual\u00a0earnings.',
  'the_market.section.other_factors':
    'Curious as to what other factors impact potential\u00a0earnings?',
  'the_market.button_text': 'Next',

  // Pricing - Check In Price
  'pricing.check-in.title.initial-approved': `Prices adjust automatically based on interest. Let’s align on a Floor Price so we can move quickly on your\u00a0behalf.`,
  'pricing.check-in.title.initial-not-approved': `Once we finalize a listing price with you, we make adjustments based on resident interest and are 100% aligned in getting you the most for your home\u00a0ASAP.`,
  'pricing.check-in.critical.title': `Why? Because the first weeks on market are the most\u00a0critical.`,
  'pricing.check-in.critical.content': `Zillow and other major listing sites move your home lower on their search results the longer it is live. It is critical to list at a competitive price and lower price quickly if we don’t see immediate\u00a0interest.`,
  'pricing.check-in.table.title': `Based on our experience with thousands of homes, we built these guidelines for adjusting\u00a0pricing. `,
  'pricing.check-in.automatic-pricing.section-title': `Setting a Floor Price gives us the ability to adjust prices automatically and quickly, minimizing\u00a0vacancy. `,
  'pricing.check-in.automatic-pricing.title': `<b>Prices adjust automatically</b> based on demand, starting after the first 4\u00a0days.`,
  'pricing.check-in.check-points.title': `We'll reach out to you if demand suggests the price should drop below this\u00a0price.`,
  'pricing.check-in.check-points.title-with-diff': `We'll reach out to you if demand suggests the price should drop below this Floor Price, {priceDiff} below your initial listing\u00a0price.`,
  'pricing.check-in.weekly-updates.title': `You’ll recieve frequent <b>email updates</b> about demand and price\u00a0changes.`,
  'pricing.check-in.cta.initial-approved': `Let's list!`,
  'pricing.check-in.cta.initial-not-approved': `Makes sense!`,
  'pricing.check-in.cta.initial-not-happy': `Let's discuss!`,
  'pricing.check-in.how-do-you-feel': `How do you feel about our\u00a0strategy?`,
  'pricing.check-in.our-strategy': `Our strategy successfully maximized earnings by balancing vacancy and rent price for thousands of homeowners. Tell me what's on your\u00a0mind.`,
  'pricing.check-in.tell-us-how-you-feel': `What's on your mind?`,
  'pricing.check-in.cta.with-feedback': `Submit`,
  'pricing.check-in.toast': `Success! You confirmed a Floor Price of {checkInPrice}. We will get busy preparing to list.`,
  'pricing.check-in.toast-bad-sentiment':
    "We'll make sure we can discuss our pricing strategy once more before we\u00a0list.",

  // Pricing - Tour Strategy
  'pricing.tour-strategy.title': `You've got your price, {firstName}. Last step: how we show your home so it leases\u00a0fast.`,
  'pricing.tour-strategy.heading':
    'Decide how you want us to show your\u00a0home...',
  'pricing.tour-strategy.heading-mobile': `How we'll show your home`,
  'pricing.tour-strategy.full-access.name': 'Full Access',
  'pricing.tour-strategy.full-access.badge': 'Recommended',
  'pricing.tour-strategy.full-access.description':
    'Self tours, plus hosted open homes. The most tour times, the fastest\u00a0lease.',
  'pricing.tour-strategy.full-access.price': 'Included',
  'pricing.tour-strategy.full-access.price-caption': 'Nothing due today',
  'pricing.tour-strategy.full-access.footnote':
    'Full Access selected. Nothing to pay, and your home gets the most tour\u00a0coverage.',
  'pricing.tour-strategy.white-glove.name': 'White Glove',
  'pricing.tour-strategy.white-glove.badge': 'Premium',
  'pricing.tour-strategy.white-glove.description':
    'Hosted tours only, with a Belong Pro at every single\u00a0showing.',
  'pricing.tour-strategy.white-glove.price-caption': 'One time',
  'pricing.tour-strategy.white-glove.footnote':
    'White Glove selected. A one time {feeAmount} fee applies, and is non-refundable.',
  'pricing.tour-strategy.cta': 'Done',
  'pricing.tour-strategy.save-error':
    "We couldn't save your choice. Please try again.",

  'pricing.tour-strategy.self-tours.title':
    'How we keep your home safe with self\u00a0tours.',
  'pricing.tour-strategy.self-tours.subtitle':
    'Every visitor is a vetted future resident, and your home is protected at each\u00a0step.',
  'pricing.tour-strategy.self-tours.verified-id.title':
    'Verified Government ID',
  'pricing.tour-strategy.self-tours.verified-id.description':
    'We confirm every visitor is who they say they are before they can\u00a0tour.',
  'pricing.tour-strategy.self-tours.one-time-access.title':
    'Access Only For a Booked Visit',
  'pricing.tour-strategy.self-tours.one-time-access.description':
    'Entry details go only to a verified visitor, for a tour they booked at a set\u00a0time.',
  'pricing.tour-strategy.self-tours.refundable-hold.title':
    'A {holdAmount} Refundable Hold',
  'pricing.tour-strategy.self-tours.refundable-hold.description':
    "We place a hold on every visitor's card before access, so everyone touring has real\u00a0accountability.",
  'pricing.tour-strategy.self-tours.photos-review.title':
    'Locked Up And Verified',
  'pricing.tour-strategy.self-tours.photos-review.description':
    'After every tour, our team reviews the visit to confirm your home was left locked and\u00a0secure.',

  'pricing.tour-strategy.white-glove-details.title':
    'Your home is never shown\u00a0alone.',
  'pricing.tour-strategy.white-glove-details.subtitle':
    'White glove trades the reach of self tours for a hands on service, with a person looking after every\u00a0visit.',
  'pricing.tour-strategy.white-glove-details.same-advisor.title':
    'A Belong Pro Hosts Every Showing',
  'pricing.tour-strategy.white-glove-details.same-advisor.description':
    'A Belong Pro greets your visitors, shows your home in person, and answers their questions on the\u00a0spot.',
  'pricing.tour-strategy.white-glove-details.home-readied.title':
    'Never Shown Unattended',
  'pricing.tour-strategy.white-glove-details.home-readied.description':
    'Because every visit is hosted, no one is ever inside your home without a Belong Pro\u00a0present.',
  'pricing.tour-strategy.white-glove-details.feedback.title':
    'Anything Off Gets Flagged',
  'pricing.tour-strategy.white-glove-details.feedback.description':
    'Because a Belong Pro is there in person, they can spot and report anything that needs\u00a0attention.',
  'pricing.tour-strategy.white-glove-details.secured.title':
    'Secured By A Belong Pro',
  'pricing.tour-strategy.white-glove-details.secured.description':
    'Your Belong Pro checks the doors, windows, and lights before leaving, every\u00a0time.',

  // Pricing - Strategy
  'pricing.strategy.title':
    'Based on years or research, our strategy involves small, frequent, automated price adjustments based on demand to maximize your rental price, and avoid costly extended periods of\u00a0vacancy.',
  'pricing.strategy.all-major-sites': 'Listed On All Major\u00a0Sites',
  'pricing.strategy.all_major_sites_description':
    'Our direct integrations with Zillow, Trulia, Zumper, and Hotpads boost your listing’s visibility by 30% to 50%.',
  'pricing.strategy.touring-your-home': 'Scheduled & On\u00a0Demand\u00a0Tours',
  'pricing.strategy.touring-your-home_description':
    'We host weekly open home tours led by professional hosts. For those who cannot attend, we offer private tours at times that work for\u00a0them.',
  'pricing.strategy.zillow-preferential-partnership':
    'Zillow Preferential Partnership',
  'pricing.strategy.zillow-preferential-partnership_description':
    'Our leasing team connects with potential residents within 5 minutes, highlighting the value of your home, neighborhood, and peace of mind Belong offers.',
  'pricing.strategy.dedicated-team-outreach': 'Dedicated Team Outreach',
  'pricing.strategy.dedicated-team-outreach_description':
    'Our integration with sites like Zillow allow for real time outreach. Our team is able to meet application and tour requests seamlessly.',
  'pricing.strategy.first-4-days-title': 'Every 4 Days',
  'pricing.strategy.first-4-days-description':
    'We’ll adjust prices based on the number of leads, tour\u00a0attendees, and\u00a0applications we\u00a0received.',
  'pricing.strategy.capped-title': '1 - 4.95% Adjustments',
  'pricing.strategy.capped-description':
    'Listing prices go up or down automatically in small increments until there is sufficient\u00a0demand.',
  'pricing.strategy.notified-callout':
    'You’ll be notified of all changes, and receive a weekly\u00a0analysis of the demand your home is\u00a0receiving.',
  'pricing.strategy.employee_reminder':
    "Our strategy has successfully maximized earnings by balancing between vacany and price for thousands of Belong homeowners. We want the same for you. Tell us what's on your\u00a0mind.",
  'pricing.strategy.sentiment-title': `How do you feel about our\u00a0strategy?`,
  'pricing.strategy.tell-us-how-you-feel':
    'Tell us more about how you\u00a0feel!',
  'pricing.strategy.marketing-message':
    'Automated pricing, combined with best-in-class marketing and a responsive team, yield the best\u00a0results.',
  'pricing.strategy.strategy-overview-card-title': 'Pricing Strategy Overview',
  'pricing.strategy.strategy-overview-card-subtitle': '1 Minute Video',
  'pricing.strategy.strategy-overview-card-play-button': 'Watch Now',
  'pricing.strategy.cta': 'Sounds good!',
  'pricing.strategy.bad-sentiment-cta': "Let's discuss!",

  // Success
  'success.title.approved': `And we’re off! We have everything we need from you right now to hit the ground running. Rest assured, you're in good hands, and your home will be receiving all the love it\u00a0deserves.`,
  'success.title.not-approved': `We have your feedback and will follow up with you soon! Rest assured, you're in good hands and we will make sure your home receives all the love it\u00a0deserves.`,
  'success.whats-next': `What's next?`,
  'success.steps.setup-account': `Setup Your Account`,
  'success.steps.your-plan': `Finalize Your Plan`,
  'success.steps.improvements': `Improvements & Reconditioning`,
  'success.steps.photos-media': `Photos & Media`,
  'success.steps.listing-showing': `Listing & Showings`,
  'success.cta': `View Your Account`,

  // Smooth Payments
  'smooth-payments.full-amount.title':
    'Alright! You’ve unlocked Smooth Payments™! We’ll send you ${rent} on the 1st, in anticipation of finding residents at that rental\u00a0price.',
  'smooth-payments.prorated.title':
    "Alright! You’ve unlocked Smooth Rent Payments! We're sending you the remainder of the month (${currentRent}) now, in anticipation of finding residents at that ${nextRent} rental\u00a0price.",
  'smooth-payments.enabled': 'SMOOTH PAYMENTS™ ENABLED',
  'smooth-payments.free-text': 'FREE',
  'smooth-payments.submit.enabled': 'Sounds Great!',
  'smooth-payments.submit.disabled': 'No, thanks!',
  'smooth-payments.modal-title': 'Enabling Smooth\u00a0Payments™',
  'smooth-payments.start-receiving.section-title':
    'Start receiving rent\u00a0immediately. Enable\u00a0Smooth\u00a0Payments™!',
  'smooth-payments.free.subtitle': '100% Free • No\u00a0Fees\u00a0Whatsoever',
  'smooth-payments.details-text':
    'Periods of vacancy can be difficult financially, especially with a mortgage or HOA fees. With Belong Smooth Payments™, you keep receiving rent while we focus on finding someone to love your home, all at no\u00a0additional\u00a0cost.',
  'smooth-payments.starting-today.title': 'Starting today...',
  'smooth-payments.starting-today.text':
    'Receive Smooth Payments™ monthly until we find someone to love\u00a0your\u00a0home.',
  'smooth-payments.placed-residents.title': 'Once we place a\u00a0resident...',
  'smooth-payments.placed-residents.text':
    'We’ll deduct 1/12th of all Smooth\u00a0Payments™ you received each month over the course of 12 months, the length of our standard\u00a0lease.',
  'smooth-payments.why.title': 'Why?',
  'smooth-payments.why.text':
    'Because a bird in the hand is worth two in the Belong\u00a0bush.',
  'smooth-payments.modal.title': 'Introducing Smooth\u00a0Payments™',
  'smooth-payments.modal.secondary-title': 'Only At Belong',
  'smooth-payments.standalone.success.title':
    "Smooth! You'll be receiving your first Smooth\u00a0Payment™ shortly.",
  'pay-out-of-pocket': 'Pay Out Of Pocket',
  'complimentary-repairs': 'Complimentary Repairs',
  'with-exclusivity': 'With Contract',
  'exclusivity-banner':
    'Belong will cover the cost of all improvements highlighted above with a {years} year agreement. If you decide to sell your home or end your relationship with Belong before the {years}-year term is up, simply repay the cost of the covered repairs, plus interest. This allows you to maintain flexibility while benefiting from immediate improvements. We’re committed to making home management easier, even when your circumstances\u00a0change.',
  'exclusivity-agreement': 'I AGREE TO SIGN THESE TERMS AND\u00a0CONDITIONS',
  'improvements-report-cost.repairs-valued-at': 'Repairs Valued At',
  'improvements-report-cost.you-pay': 'You Pay',
  'exclusivity-agreement-url': 'View Agreement',
};
